import type { jiraNumberFieldFragment as NumberField } from '@atlassian/jira-business-fields/src/common/field-types/number/fragment/__generated_apollo__/jiraNumberFieldFragment.ts';
import {
	NUMBER_CF_TYPE,
	STORY_POINTS_TYPE,
	STORY_POINT_ESTIMATE_CF_TYPE,
} from '@atlassian/jira-platform-field-config';
import type { DataTransformFn } from '../../../bulk-edit-transform/types';
import type { NumberFormData } from './types';

export const transformNumberFieldForOptimisticUpdates: DataTransformFn<
	NumberField,
	NumberFormData
> = (existingField: NumberField, fieldData: NumberFormData): NumberField => ({
	...existingField,
	number: fieldData,
});

export const numberOptimisticUpdatesHandler: {
	[key: string]: DataTransformFn<NumberField, NumberFormData>;
} = {
	[NUMBER_CF_TYPE]: transformNumberFieldForOptimisticUpdates,
	[STORY_POINTS_TYPE]: transformNumberFieldForOptimisticUpdates,
	[STORY_POINT_ESTIMATE_CF_TYPE]: transformNumberFieldForOptimisticUpdates,
};
